import React, { useState } from 'react';

const ValuesSection = () => {
  const [videoError, setVideoError] = useState(false);

  return (
    <section className="bg-warm-taupe py-20 md:py-32">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center mb-16">
          <h2 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-espresso mb-8">
            Our Values
          </h2>
          <div className="h-1 w-24 bg-dull-gold mx-auto mb-12"></div>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <p className="font-nunito text-espresso text-base md:text-lg leading-relaxed text-center">
            At The Brunch Club, we've never set out to do things the usual way. From the 
            very beginning, our mission has been to reimagine what Indian hospitality can 
            be – modern, rooted, bold, and full of heart. And the only way to build something 
            this ambitious, this personal, is by holding ourselves to a set of values that 
            guide us through every high and every challenge.
          </p>
          <p className="font-nunito text-espresso text-base md:text-lg leading-relaxed text-center mt-6">
            These values aren't just words on a wall. They shape how we show up for each 
            other, how we treat our guests, how we lead, and how we grow. This is New Age 
            Indian Hospitality. And these are the values that make it possible.
          </p>
        </div>

        {/* Video Section */}
        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
          <div className="aspect-video bg-warm-taupe/20 flex items-center justify-center">
            {!videoError ? (
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover"
                poster="/images/values-poster.jpg"
                onError={() => setVideoError(true)}
              >
                <source src="/videos/VIDEO-2025-10-28-15-36-32.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            ) : (
              /* Fallback message when video is not available */
              <div className="absolute inset-0 flex items-center justify-center text-espresso font-nunito text-center p-8">
                <div>
                  <svg className="w-16 h-16 mx-auto mb-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                  <p className="text-lg">Video will appear here</p>
                  <p className="text-sm mt-2 opacity-70">Add your values video to /public/videos/values-video.mp4</p>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-20">
          {[
            {
              title: 'Authenticity',
              description: 'We stay true to our roots while embracing innovation, creating experiences that are genuine and memorable.',
            },
            {
              title: 'Excellence',
              description: 'From ingredients to service, we pursue the highest standards in everything we do.',
            },
            {
              title: 'Community',
              description: 'We build lasting relationships with our guests, team, and local communities.',
            },
          ].map((value, index) => (
            <div
              key={index}
              className="text-center p-8 rounded-xl bg-espresso hover:bg-[#1c1c2e] transition-all duration-300 transform hover:-translate-y-2"
            >
              <h3 className="font-playfair text-2xl font-bold text-dull-gold mb-4">
                {value.title}
              </h3>
              <p className="font-nunito text-cream leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;

